<template>
    <main class="bg-white page-home">
        <section
            class="px-4 mx-auto block bg-neutral-100 lg:grid lg:grid-cols-6 lg:gap-8 lg:w-full xl:px-0 xl:grid-cols-5"
        >
            <div class="lg:col-span-2 xl:col-span-1">
                <FilterOptions/>
            </div>
            <div class="lg:col-span-4 lg:pr-8 xl:col-span-3 2xl:col-span-4 2xl:pr-16">
                <Breadcrumb/>
                <section class="container mx-auto grid gap-x-8 gap-y-16 py-16 md:grid-cols-2 2xl:grid-cols-3">
                    <NuxtLink
                        v-for="category in categories"
                        :id="'menu-item-' + category._id"
                        :key="category._id"
                        class="panel"
                        role="menuitem"
                        tabindex="-1"
                        :to="{
                            name:'category',
                            params: {
                                id: String(category._id),
                                name: StringTools.simplify(category.name),
                            }
                        }"
                    >
                        <NuxtPicture
                            :src="'categories/' + (category.image?.filename ?? 'placeholder.jpg')"
                        />
                        <p class="uppercase text-base font-semibold text-center text-neutral-500! px-4 lg:text-lg">
                            {{ category.name }}
                        </p>
                        <UButton
                            class="absolute -bottom-4"
                            color="secondary"
                            label="Jetzt entdecken"
                            variant="outline"
                        />
                    </NuxtLink>
                </section>
            </div>
        </section>

        <section class="bg-neutral-100 py-16">
            <div class="container mx-auto text-lg">
                <h1 class="text-5xl! text-secondary! font-normal! normal-case!">
                    Produkte
                </h1>
                <p class="text-primary! font-bold">
                    Unsere Spielplätze bieten Ihren Kindern nicht nur Spielspaß, sondern auch Raum für die Entwicklung
                    ihrer motorischen, sowie kreativen Fähigkeiten.
                </p>
                <p>
                    Unsere Vision vom spielerischen Miteinander berücksichtigt die Faktoren Spaß und Lernen in
                    besonderem Maße: generationsübergreifend, kommunikativ und toleranzbildend.
                </p>
                <p>
                    Die passenden Spielgeräte bieten Ihren Kindern Freude an Bewegung, fördern ihre Körperbeherrschung
                    und das Miteinander.
                </p>
            </div>
        </section>
    </main>
</template>

<script lang="ts" setup>
import {StringTools} from '~~/utils/StringTools';
import {useMainCategories} from '~/composables/useMainCategories';
import FilterOptions from '~/components/FilterOptions.vue';

definePageMeta({
    path: '/kategorien',
});

const categories = ref(await useMainCategories());
const header = useState<{ title: string; subTitle: string }>(
    'header',
);
header.value = {
    title: 'Unsere Produkte',
    subTitle: 'eine Welt voller Vielfalt',
};
</script>
